import React, { useState } from 'react'
import { addParticipantToCourse } from '../../utils/Network'
import SelectCourses from '../SelectCourses'

function AddToCourseForm({usertalent,userdocument,...props}) {

    const [course,setCourse] = useState(null)
    const [loading,setLoading] = useState(false)
    const [error,setError] = useState(null)
    const [done,setDone] = useState(null)
    
    const SaveChanges = () => {

        setError(null)
        
        if (!course) {
            setError("Please select a contest")
            return;
        }

        setLoading(true)
        addParticipantToCourse(course, usertalent, [userdocument]).then(data => {
                setDone("Changes saved successfully");
                props.callback()
        })
    }

    
    const onValue =  (value, name)  => {
        //alert(e.target.name)
        switch (name) {
            case 'course':
                setCourse(value)
                break;
            default:

                break;
        }
    }

  return (
    <div>
        <div className="form-group">
            <SelectCourses
                width="100%"
                value={course}
                border="1"
                callback={onValue}
            />
        </div>
        <div className="form-group mt-10">
            <button className="btn btn-primary pull-right" onClick={SaveChanges}>{loading ? "": "Save Changes"  }</button>
            <div className="clear"></div>
        </div>
        {error &&
            <div className="alert alert-danger mt-5">
                {error}
            </div>
        }
        {loading &&
            <div className="alert alert-info  mt-5">
                Please Wait...
            </div>
        }
        {done &&
            <div className="alert alert-success  mt-5">
                {done}
            </div>
        }
    </div>
  )
}

export default AddToCourseForm